import {Service} from "@/services/Service";

export class CatalogosService extends Service {
    constructor(axios) {
        super(axios, "/cat");
    }

    obtenerAreasPredet(params) {
        this.onStart();
        return this.http.post(this.getUrl(['/obtenerAreasPredet/']), params)
            .then((response) => JSON.parse(response.data))
            .catch(e =>this.onError(e))
            .finally(() => {
                this.onFinaly();
            })
    }

}